
import { forwardRef } from   'react';
import PropTypes from 'prop-types';
import { InputGroup } from 'react-bootstrap';
import { FaCalendar } from 'react-icons/fa';

const CustomInput = forwardRef(({ value = '', onClick }, ref) => (
            <button
                type="button"
                className="btn btn-light"
                onClick={(e) => onClick?.(e)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onClick?.(e);
                    }
                }}
                ref={ref}
                aria-label="Seleccionar fecha"
                style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
            >
                <InputGroup>
                    <InputGroup.Text>
                        <input value={value} readOnly className='widthCalendar' style={{border:'0'}}/>
                    </InputGroup.Text>
                    <InputGroup.Text>
                        <FaCalendar size={20} />
                    </InputGroup.Text>
                </InputGroup>
            </button>
        ));


CustomInput.propTypes = {
    value: PropTypes.any,
    onClick: PropTypes.func,
};


export default CustomInput;